import { render, staticRenderFns } from "./BeauticianPasswordReset.vue?vue&type=template&id=99de07a0"
import script from "./BeauticianPasswordReset.vue?vue&type=script&lang=js"
export * from "./BeauticianPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports